import React from 'react'
import { connect } from 'react-redux'

// Higher-order component to show NotFound for viewers trying to access restricted routes
const withViewerRedirect = (Component) => {
  const WithViewerRedirect = (props) => {
    // If the user is a viewer (or only has project access), return null to mimic the page/route not existing
    if (props.company && ['VIEWER', 'PROJECT_ONLY'].includes(props.company.my_role)) {
      console.log('Viewer accessing restricted route - returning null')
      return null
    }

    // Otherwise render the original component
    return <Component {...props} />
  }

  // Connect to redux store to get company data
  return connect(
    state => ({
      company: state.companies.active
    })
  )(WithViewerRedirect)
}

export default withViewerRedirect
